import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup, FormControl, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { APILoginService } from '../../_services/login/API-login';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { APIEntityService } from '../../_services/entity/API-entity';
import { PasswordValidation } from './password-match';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import * as crypto from 'crypto-js';

@Component({
	selector: 'app-change-password',
	templateUrl: './change-password.component.html',
	styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {


	forgotPasswordForm: FormGroup;
	changepwdotp: FormGroup;
	updateEntityForm: FormGroup;
	updatePasswordForm: FormGroup;

	generate = true;
	verifyotp = false;
	changePassword = false;
	currentMail = "";

	submitted1 = false;
	submitted2 = false;
	submitted3 = false;
	notApprovedMail = false;
	otpNO: number;
	public signinshow: boolean = false;
	otpFlag: boolean = false;
	disableResend: boolean = false;
	count: number = 0;

	otpEExp: any;
	otpMExp: any;
	otpEmail: any;
	otpMobile: any;
	//entity_class: any;
	resendOTPDiable: boolean = false;
	afterSubmit: boolean = true;
	refno: any;
	entityId: any;
	entityId1: any;

	constructor(private formBuilder: FormBuilder,
		private router: Router,
		private _route: ActivatedRoute,
		private $modal: $ModalManagerService,
		private ls: APILoginService,
		private es: APIEntityService,
		private db: $DBManagerService,
		) {
       this._route.params.subscribe((params) => {
            //this.entity_class = params['role'];
			})
			
		}

	ngOnInit() {
		this.updatePasswordForm = this.formBuilder.group({
			old_pwd: ['', [Validators.pattern]],
			new_pwd: ['', [Validators.pattern]],
			cnf_pwd: ['',],
			entity_id: ['',],


		}, 
		{
				// validator: MustMatch('new_pwd', 'cnf_pwd')
				//validator: Validators.compose([ MustMatch('new_pwd', 'cnf_pwd'), NotMatch('old_pwd', 'new_pwd')])
				validator: [PasswordValidation.MustMatch('new_pwd', 'cnf_pwd'), PasswordValidation.NotMatch('old_pwd', 'new_pwd')]
			});
			

		this.changepwdotp = this.formBuilder.group({

			enter_otp: ['', [Validators.pattern("[1-9][0-9]{3}"), Validators.minLength(4)]],
		})
 

		this.entityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
		this.refno = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO_LOGIN);
		this.entityId1 = this.entityId ? this.entityId : this.refno;
        console.log("---------entity_id----------",this.entityId1)
	}
	
	onSubmit() {
		this.signinshow = true;
	}
	

	get f3() { return this.updatePasswordForm.controls; }
	get f2() { return this.changepwdotp.controls; }
	//get f1() { return this.updateEntityForm.controls; }



	resendotp() {
		this.resendOTPDiable = true
		this.count = this.count + 1;
		let data = {
			"change_otp": this.changepwdotp.get("enter_otp").value,
			"id": this.updatePasswordForm.controls.entity_id.value
			
		}

		this.es.resendOtp(data)
			.subscribe(r => {
				console.log("response -- ", r);
				console.log("status ", r.status);
				if (r.status == "success") {
					this.$modal.successModal({
						title: 'Entity Resend OTP',
						msg: 'Email OTP has been resent successfully to your registered Email ID & Mobile Number!'
					});
					this.otpEExp = r.Email_OTP_Time + 900;
					this.otpMExp = r.Mobile_OTP_Time + 900;  
					this.otpEmail = r.Email_OTP;
					this.otpMobile = r.Mobile_OTP;

				}
				else {
					this.$modal.errorModal({
						title: 'Entity Resend OTP',
						msg: 'Error in Resending the OTP!'
					});
				}
			})
		if (this.count < 3) {
			setTimeout(() => {
				this.resendOTPDiable = false
			}, 90000)
		} else {
			this.disableResend = true; 
		}
	}

	verifyOtp() {
		if (this.changepwdotp.invalid) {
			return;
		}
		else {
			this.changePassword = true;
			let data = {
				"change_otp": btoa(this.changepwdotp.get("enter_otp").value),
				"id": btoa(this.updatePasswordForm.controls.entity_id.value),
				"new_pwd": btoa(this.updatePasswordForm.get('new_pwd').value),
			}

			let eOTP = this.changepwdotp.get("enter_otp").value;
			console.log("------------eotp-----------", btoa(eOTP))
			console.log("-------------otpEmail-----------", this.otpEmail)
			let currenttime = Math.floor(new Date().getTime() / 1000)
			console.log("currenttime ", currenttime, this.otpEExp)
			if (btoa(eOTP) === this.otpEmail) {
				if (currenttime > this.otpEExp) {
					this.$modal.errorModal({
						title: 'TM/PE Password Modification',
						msg: 'OTP has expired!'
					})
					
				} else {
					this.es.changepwdVerification(data)
						.subscribe(r => {
							console.log("response -- ", r);
							if (r.status == "success") {
								this.$modal.successModal({
									title: 'TM/PE Password Modification',
									msg: 'OTP has been verified & Password has been updated successfully!'
								})
								let URNorEntityID= this.db.get(Constants.SESSSION_STORAGE, Constants.URNORENTID);
								this.ls.logOut(this.entityId1, URNorEntityID)
									.subscribe((r) => {
										console.log("r ", r)
										//sessionStorage.clear()
										this.router.navigateByUrl('/')
									})
								// this.router.navigateByUrl('/');
							}
							else {
								this.$modal.errorModal({
									title: 'TM/PE Password Modification',
									msg: 'Error in updating the Password!'
								})
							}
						})
				}
			} else {
				this.$modal.errorModal({
					title: 'TM/PE Password Modification',
					msg: 'Invalid OTP'
				})
			}
		}
	}
	
	submitPassword() {
		this.refno = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_REF_NO_LOGIN);
		this.entityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
		console.log("---------thtentityid------------",this.entityId)
		console.log("----------refno-----------",this.refno)
		// let value = this.updatePasswordForm.get('entity_id').value


		if (this.updatePasswordForm.invalid) {
			return;
		}
		// else if (value != this.refno || value != this.entityId) {
		// 	this.$modal.errorModal({
		// 		title: 'Entity Password',
		// 		msg: 'This is not your Entity ID/Reference No'
		// 	});
		// }
		 else {
			if (!this.otpFlag) {
			this.afterSubmit = false;
			let data = {

					// "id": btoa(this.updatePasswordForm.get('entity_id').value),
					"id": btoa(this.entityId ? this.entityId : this.refno),
					"old_pwd": btoa(this.updatePasswordForm.get('old_pwd').value),
					"new_pwd": btoa(this.updatePasswordForm.get('new_pwd').value),
					"cnf_pwd": btoa(this.updatePasswordForm.get('cnf_pwd').value),
				
				//"EntityClass":this.entity_class
			}

			this.es.PwdChange(data)
				.subscribe(r => {

					if (r.status == "success") {
						//this.emailmobotp=true;
						this.otpFlag = true;
						this.$modal.successModal({
							title: 'Entity Password',
							msg: 'OTP has been sent to your registered EmailID & Mobile. Please enter the OTP to change your password.'
						});
						this.otpEExp = r.Email_OTP_Time + 900;
						this.otpMExp = r.Mobile_OTP_Time + 900;
						this.otpEmail = r.Email_OTP;
						this.otpMobile = r.Mobile_OTP;
					} else if (r.status == "fail") { 
					    this.otpFlag = false;
						if (r.err == "Not Exists") {
							this.$modal.errorModal({
								title: 'Entity Password',
								msg: 'Incorrect Entity ID entered, please Provide correct Entity ID!'
							});
						}
						else if (r.err == "Error updating db") {
							this.$modal.errorModal({
								title: 'Entity Password',
								msg: 'Error in updating the password'
							});
						}
						else if (r.err == "Password doesnt match") {
							this.$modal.errorModal({
								title: 'Entity Password',
								msg: 'Incorrect old password!'
							});
								this.afterSubmit = true;
						}
							else if (r.err == "Not PE/TM") {
							this.$modal.errorModal({
								title: 'Entity Password',
								msg: 'Please Enter a valid ID!'
							});
						}
							else {
							this.$modal.errorModal({
								title: 'Entity Password',
								msg: 'Error sending OTP!'
							});
						}
						
					} 
				})
		    }
		}



	}




}

